import { GpsDataType } from 'app/constants/gpsDataType'

export const getGpsDataType = (type: number) => {
  let gpsDataType = GpsDataType.BorderCrossing

  switch (type) {
    case 1:
      gpsDataType = GpsDataType.DepartureFromBase
      break
    case 2:
      gpsDataType = GpsDataType.ReturnToBase
      break
    case 3:
      gpsDataType = GpsDataType.Unknown
      break
  }

  return gpsDataType
}
